// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs--FTOIN","open":"open--IvMSN","crumb-current":"crumb-current--Cc_Is","crumbCurrent":"crumb-current--Cc_Is","crumb":"crumb--BZj_B"};